import Header from '../Header/Header';
import Area from '../Area/Area';
import { useState } from 'react';
import useIsCanInteractive from '../../model/hooks/useIsCanInteractive';
import classNames from 'classnames';

export default function InteractiveShop() {
  const highlightData = useState();
  const fullProps = { highlightData };
  const isInteractive = useIsCanInteractive(fullProps);

  return (
    <div className={classNames('interactive-shop', { 'interactive-shop_disabled': !isInteractive })}>
      <Area {...fullProps} />
      <Header {...fullProps} />
    </div>
  );
}
